import React, { useMemo, useState } from "react";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarText,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

import HeaderChild from "./HeaderChild";
import {
  fireSafetyHomeRoute,
  giftInfo,
  homeRoute,
  quickPaymentRoute,
} from "Routes/constants";

import { ReactComponent as GiftCityICon } from "assets/images/svg/logo-dark.svg";
import flagLogo from "assets/images/flag.png";
import { useMediaQuery } from "@mui/material";

const HeaderSection = ({
  menuItems = [],
  isGiftInfo,
  isFireSafety = false,
}) => {
  const sm = useMediaQuery("(max-width: 767px)");

  const headerItems = useMemo(
    () =>
      menuItems.filter(({ isHeader, contentType }) => isHeader || !contentType),
    [menuItems]
  );

  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const navToggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div className="d-flex align-items-center justify-content-between navbar-wrapper">
      <GiftCityICon
        className="gift-city-icon-wrapper"
        onClick={() =>
          navigate(
            window.location.href.includes("fire-safety")
              ? fireSafetyHomeRoute
              : homeRoute
          )
        }
      />
      <div className="d-flex align-items-center justify-content-between navbar-right-wrapper">
        <div className="navbar-inner-wrapper">
          <Navbar expand="md">
            <NavbarBrand>
              <GiftCityICon
                className="gift-city-icon-wrapper"
                onClick={() =>
                  navigate(
                    window.location.href.includes("fire-safety")
                      ? fireSafetyHomeRoute
                      : homeRoute
                  )
                }
              />
            </NavbarBrand>
            <NavbarToggler onClick={navToggle} />
            <Collapse isOpen={isOpen} navbar className={sm ? "bg-white" : ""}>
              <Nav className="me-auto d-flex" navbar>
                {!!menuItems.length && !isFireSafety && (
                  <NavItem>
                    <NavLink
                      onClick={() => navigate(quickPaymentRoute)}
                      className="navbar-options cursor-pointer"
                    >
                      Quick Pay
                    </NavLink>
                  </NavItem>
                )}
                {!!menuItems.length && !isFireSafety && (
                  <NavItem>
                    <NavLink
                      onClick={() => navigate(fireSafetyHomeRoute)}
                      className="navbar-options cursor-pointer"
                    >
                      Fire Life Safety
                    </NavLink>
                  </NavItem>
                )}
                {isFireSafety && (
                  <NavItem>
                    <NavLink
                      onClick={() => navigate(homeRoute)}
                      className="navbar-options cursor-pointer"
                    >
                      Gift Utilities
                    </NavLink>
                  </NavItem>
                )}
                {headerItems.map(({ id, name, child }, index) =>
                  !child.length ? (
                    <NavItem key={index}>
                      <NavLink
                        onClick={() =>
                          navigate(giftInfo, {
                            state: {
                              id,
                            },
                          })
                        }
                        className="navbar-options home"
                      >
                        {name}
                      </NavLink>
                    </NavItem>
                  ) : (
                    <HeaderChild
                      key={index}
                      child={child}
                      headerName={name}
                      isGiftInfo={isGiftInfo}
                    />
                  )
                )}
              </Nav>
              <NavbarText className="flag-display">
                <div className="img-wrapper">
                  <img src={flagLogo} alt="flag" />
                </div>
              </NavbarText>
            </Collapse>
          </Navbar>
        </div>
        <div className="img-wrapper flag-display">
          <img src={flagLogo} alt="flag" />
        </div>
      </div>
    </div>
  );
};

export default HeaderSection;

HeaderSection.propTypes = {
  menuItems: PropTypes.array,
  isGiftInfo: PropTypes.bool,
  isFireSafety: PropTypes.bool,
};
